export default {
  "content": "<title>Send</title><path d=\"M16 464l480-208L16 48v160l320 48-320 48z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};